import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { TagModel } from '@core/models/tag.model';
import * as fromRoot from '@core/redux';
import { Store } from '@ngrx/store';

import { SettingTagItemComponent } from '../setting-tag-item/setting-tag-item.component';

@Component({
  selector: 'app-setting-tag-list',
  templateUrl: './setting-tag-list.component.html',
  styleUrls: ['./setting-tag-list.component.less'],
  imports: [SettingTagItemComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingTagListComponent {
  private readonly store = inject<Store<fromRoot.State>>(Store);

  protected readonly tags = toSignal(this.store.select(fromRoot.getTagEntities), { initialValue: [] as TagModel[] });

  protected readonly emptyTag = new TagModel();
}
